export default __webpack_public_path__ + "53e067b519d24b5cd893258abeda11a2.svg";